import React from "react";

const SvgCheckmarkLight = props => <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}><path d="M.7 12.6l12.8 13 17.7-22" stroke="currentColor" strokeWidth={2} /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/checkmark-light_296c2a.svg";
export { SvgCheckmarkLight as ReactComponent };